import {call, put, takeLatest} from "redux-saga/effects";
import {InitAction, InvitationAction, NotificationAction, ProjectAction, ProjectSettingAction} from "../actions";
import * as types from "../actions/actionTypes";
import * as invitationApi from "../api/invitation";
import {toastr} from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
import {SetMessage} from "../assets/errorMessages";

export function* watcherInvitation() {
  yield takeLatest(types.INVITATION_ACCEPT_REQUEST, workerAccept);
  yield takeLatest(types.INVITATION_REJECT_REQUEST, workerReject);
  yield takeLatest(types.SEND_SMS_REQUEST, workerSms);
  yield takeLatest(types.INVITE_REQUEST, workerInvite);
  yield takeLatest(types.CHECK_PHONE_NUMBER_REQUEST, workerCheckPhoneNumber);
  yield takeLatest(types.INVITE_TO_APP_REQUEST, workerInviteToApp);
}

async function sendAcceptRequest(id) {
  return invitationApi.accept(id);
}
function* workerAccept(action) {
  try {
    const response = yield call(sendAcceptRequest, action.payLoad);
    const data = response.data;
    yield put(NotificationAction.setNotificationCount(data.count, data.feedback_count));
    yield put(
      InvitationAction.acceptSuccess(action.payLoad, data.data)
    );
    yield put(ProjectAction.acceptSuccess(data.project));

  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(InvitationAction.acceptFailure(action.payLoad));
  }
}

async function sendRejectRequest(id) {
  return invitationApi.reject(id);
}
function* workerReject(action) {
  try {
    const response = yield call(sendRejectRequest, action.payLoad);
    const data = response.data;
    yield put(NotificationAction.setNotificationCount(data.count, data.feedback_count));
    yield put(
      InvitationAction.rejectSuccess(action.payLoad, data.data)
    );
    yield put(ProjectAction.rejectSuccess(action.payLoad));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(InvitationAction.rejectFailure(action.payLoad));
  }
}

async function sendSms(token) {
  return invitationApi.sendSms(token);
}
function* workerSms(action) {
  try {
    const response = yield call(sendSms, action.payLoad);
    yield put(InvitationAction.sendSmsSuccess(response.data));
    yield put(ProjectSettingAction.sharedContacts());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.sendSmsFailure(action.payLoad));
  }
}

async function invite(data) {
  return invitationApi.invite(data);
}
function* workerInvite(action) {
  try {
    const response = yield call(invite, action.payLoad);
    yield put(InitAction.getSuccess({ user_counts: response.data.user_counts }));
    yield put(InvitationAction.inviteSuccess(response.data));
    yield put(ProjectSettingAction.sharedContacts());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.inviteFailure(action.payLoad));
  }
}

async function checkPhoneNumber(data) {
  return invitationApi.checkPhoneNumber(data);
}
function* workerCheckPhoneNumber(action) {
  try {
    const response = yield call(checkPhoneNumber, action.payLoad);
    yield put(InvitationAction.checkPhoneNumberSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(InvitationAction.checkPhoneNumberFailure(error.response.data));
  }
}

function inviteToAppRequest(data) {
  return invitationApi.inviteToApp(data);
}

function* workerInviteToApp(action) {
  try {
    const response = yield call(inviteToAppRequest, action.data);
    yield put(
      InvitationAction.inviteToAppSuccess({
        data: response.data,
        phoneNumber: action.phoneNumber
      })
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(InvitationAction.inviteToAppFailure());
  }
}
